import React, { useEffect, useState, useRef } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { showToast } from "../../Common/Messages";
import Topic from "../Topic";
import PopUp from "../../Common/PopUp";
const DocHome = (props) => {
    const LoginStates = useSelector(state => state.login);
    const [editorInfo, setEditorInfo] = useState(null);
    const [bestList, setBestList] = useState(null)
    const [mostViewList, setMostViewList] = useState(null)
    const [boxTopicList, setBoxTopicList] = useState(null)
    const [workingList, setWorkingList] = useState(null)
    const [requestList, setRequestList] = useState(null)
    const [completeList, setCompleteList] = useState(null)
    const [publishList, setPublishList] = useState(null)
    const [openSetting, setOpenSetting] = useState(false);
    const [openTopic, setOpenTopic] = useState(false);
    const [popupContent, setPopupContent] = useState(null);

    const [state, setState] = useState({
        catagoryList: [],
        current: 'topicList',
        currentPage: 1,
        content: '',
        docPath: '',
        selectedCatagorySeq: 0,
        topicList: [],
        topicView: [],
        subTopic: [],
        topicSeq: 0,
        isReceiveMail: '0',
        workingTag: 'A',
        popupContent: null,
        pageCount: 10
    });

    useEffect(() => {
        if (props.docBox?.docBoxPath) {
            getDocList();
            getEditorInfo();
        }

        return () => {

        }
    }, [props.docBox]);

    const getEditorInfo = async () => {
        const body = {
            docBoxSeq: props.docBox.docBoxSeq,
            devUserId: LoginStates.userId
        }
        const response = await fetch("api/Edit/GetDocBoxMember", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.status === 200 && result.data) {
            if (result.data.table && result.data.table.length > 0)
                setEditorInfo(result.data.table[0]);
            else
                setEditorInfo(null);
        } else {
            showToast('danger', '정보 조회 실패');
        }
    }

    const getDocList = async (state = false, tag = "All") => {
        const body = {
            folderName: props.docBox.docBoxPath,
            devUserId: state ? LoginStates.userId : ""
        }
        const response = await fetch(`api/Edit/GetBoxDocumentList/${tag}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.status === 200 && result.data) {
            if (tag === "All") {
                working(result.data.table);
                request(result.data.table1);
                complete(result.data.table1);
                publish(result.data.table2);
                best(result.data.table3);
                mostView(result.data.table4);
                if (result.data.table5) {
                    setState(prev => {
                        return {
                            ...prev,
                            current: 'topicList',
                            topicList: result.data.table5,
                            catagoryList: result.data.table6,
                            topicView: [],
                            subTopic: [],
                            selectedCatagorySeq: 0,
                            title: '',
                            content: '',
                            isReceiveMail: '0',
                            workingTag: 'A'
                        }
                    });
                    boxTopic(result.data.table5);
                }
            } else {
                return result.data.table;
            }
        }
    }
    const handleClick = (doc) => {
        props.getManual({ item: { docId: doc.docID, module: doc.title }, name: doc.title });
    }

    const btnOnPopup = (e, item) => {
        setPopupContent(item ? renderMoreMenu(e, item) : null);
    }

    const formattedDateTime = (dateTime) => {
        const year = dateTime.getFullYear();
        const month = String(dateTime.getMonth() + 1).padStart(2, '0');
        const date = String(dateTime.getDate()).padStart(2, '0');
        return `${year}-${month}-${date}`;
    }
    const best = (list) => {
        setBestList(
            <div className='docbox bg-cyan'>
                <div className="docbox-title-wrap">
                    <i className="icoKdc24 thumbsup"></i>
                    <h3 className='docbox-title'>도움을 준 문서</h3>
                </div>
                <div className="docbox-cnts-wrap">
                    <ul className="docbox-cnts-list">
                        {list && list.length > 0 ? 
                            list.map((doc, index) => {
                                return (
                                    <li key={index}>
                                        <Link onClick={() => handleClick(doc)}>
                                            <div class="docbox-item-title">
                                                <p className="docbox-item-rank cyan">{index + 1}</p>
                                                <p className='docbox-cnts'>{doc.title}</p>
                                            </div>
                                            <div className="post-stats">
                                                <i className="icoKdc16 thumbsup-16"></i>
                                                <p className="count">{doc.count}</p>
                                            </div>
                                        </Link>
                                    </li>
                                )
                            })
                        :   <li className="docbox-empty">
                                <Link onClick={() => { }}>
                                    <p className='msg-empty'>문서 정보가 없습니다.</p>
                                </Link>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        )
    }
    const mostView = (list) => {
        setMostViewList(
            <div className='docbox bg-green'>
                <div className="docbox-title-wrap">
                    <i className="icoKdc24 eye"></i>
                    <h3 className='docbox-title'>많이 본 문서</h3>
                </div>
                <div className="docbox-cnts-wrap">
                    <ul className="docbox-cnts-list">
                        {list && list.length > 0 ? 
                            list.map((doc, index) => {
                                return (
                                    <li key={index}>
                                        <Link onClick={() => handleClick(doc)}>
                                            <div class="docbox-item-title">
                                                <p className="docbox-item-rank green">{index + 1}</p>
                                                <p className='docbox-cnts'>{doc.title}</p>
                                            </div>
                                            <div className="post-stats">
                                                <i className="icoKdc16 view-16"></i>
                                                <p className="count">{doc.count}</p>
                                            </div>
                                        </Link>
                                    </li>
                                )
                            })
                        :   <li className="docbox-empty">
                                <Link onClick={() => { }}>
                                    <p className='msg-empty'>문서 정보가 없습니다.</p>
                                </Link>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        )
    }
    const boxTopic = (list) => {
        const dateFormat = (date) => {
            let month = date.getMonth() + 1, day = date.getDate();
            month = month >= 10 ? month : '0' + month;
            day = day >= 10 ? day : '0' + day;
    
            return date.getFullYear() + '.' + month + '.' + day;
        }
        const topicClick = (current, topicSeq = 0) => {
            setState(prev => { return { ...prev, current, topicSeq } })
            setOpenTopic(true)
        }
        setBoxTopicList(
            <div className='docbox bg-blue'>
                <div className="docbox-title-wrap">
                    <i className="icoKdc24 inquiry-24"></i>
                    <div class="docbox-title-seemore" onClick={() => topicClick('topicList')}>
                        <h3 className='docbox-title'>1:1 문의</h3>
                        <button className='btn-seemore'><i className="icoKdc20 seemore-m"></i></button>
                    </div>
                </div>
                <div className="docbox-cnts-wrap">
                    <ul className="docbox-cnts-list">
                        {list && list.length > 0 ? 
                            list.slice(0, 2).map((topic, index) => {
                                return (
                                    <li key={index}>
                                        <Link onClick={() => topicClick('topicView', topic.topicSeq)}>
                                            <div className="docbox-item-inquiry">
                                                <p className='docbox-cnts'>{topic.title}</p>
                                                <div class="icon-wrap">
                                                    <i className="icoKdc20 document"></i>
                                                    <p className="doc-name">{topic.docTitle}</p>
                                                </div>
                                            </div>
                                            <div className="post-stats">
                                                <i className="icoKdc16 reply-16"></i>
                                                <p className="count">{topic.subTopicCount}</p>
                                            </div>
                                        </Link>
                                    </li>
                                )
                            })
                        :   <li className="docbox-empty">
                                <Link onClick={() => { }}>
                                    <p className='msg-empty'>등록된 1:1 문의가 없습니다.</p>
                                </Link>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        )
    }
    const working = (list) => {
        const handleChange = async (e) => {
            const list = await getDocList(e.target.checked, "Working");
            working(list);
        };
        setWorkingList(
            <div className='docbox-col'>
                <div className="doccolumn-top">
                    <h3 className='doccolumn-title'>작성 중</h3>
                    <div className="toggle-button-cover">
                        <div className="button-cover">
                            <div className="button b2" id="button-10">
                                <input type="checkbox" className="checkbox" onChange={handleChange} />
                                <div className="knobs">
                                    <span>전체</span>
                                </div>
                                <div className="layer"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul className="docbox-col-cnts-wrap">
                    {list && list.map((doc) => {
                        return (
                            <li className='docbox-col-cnts'>
                                <div className="docbox-col-top">
                                    <div className="docbox-col-path">
                                        <span className='docbox-col-path-text'>{formattedDateTime(new Date(doc.updateDateTime))}</span>
                                    </div>
                                </div>
                                <p className='docbox-col-title' onClick={() => handleClick(doc)}>{doc.title}</p>
                                <span className='docbox-col-name'>{doc.updateUserName}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
    const request = (list) => {
        const handleChange = async (e) => {
            const list = await getDocList(e.target.checked, "Request");
            request(list);
        };
        setRequestList(
            <div className='docbox-col'>
                <div className="doccolumn-top">
                    <h3 className='doccolumn-title'>검수 중</h3>
                    <div className="toggle-button-cover">
                        <div className="button-cover">
                            <div className="button b2" id="button-10">
                                <input type="checkbox" className="checkbox" onChange={handleChange} />
                                <div className="knobs">
                                    <span>전체</span>
                                </div>
                                <div className="layer"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul className="docbox-col-cnts-wrap">
                    {list && list.map((doc) => {
                        return (
                            parseInt(doc.qaStatus) <= 2 &&
                            <li className='docbox-col-cnts'>
                                <div className="docbox-col-top">
                                    <div className="docbox-col-path">
                                        <span className='docbox-col-path-text'>{formattedDateTime(new Date(doc.updateDateTime))}</span>
                                    </div>
                                    <span className='docbox-col-badge-yellow'>검수중</span>
                                </div>
                                <p className='docbox-col-title' onClick={() => handleClick(doc)}>{doc.title}</p>
                                <span className='docbox-col-name'>{doc.updateUserName}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    const renderMoreMenu = (e, item) => {
        return(
            <div className="request">
                <div className="request-modal">
                    <div className="request-top">
                        <h3 className='request-title'>반려 사유</h3>
                        <button className="btn-close" onClick={(e) => btnOnPopup(e, null)}>
                            <i className="icoKdc32 close"></i>
                        </button>
                    </div>
                    <div className="request-cnts">
                        <div className="memo">
                            <div className="cate-top">
                                <h4 className="cate-title">{item.title}</h4>
                            </div>
                            <span>{item.qaComment}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const complete = (list) => {
        const handleChange = async (e) => {
            const list = await getDocList(e.target.checked, "Complete");
            complete(list);
        };
        setCompleteList(
            <div className='docbox-col'>
                <div className="doccolumn-top">
                    <h3 className='doccolumn-title'>검수 완료</h3>
                    <div className="toggle-button-cover">
                        <div className="button-cover">
                            <div className="button b2" id="button-10">
                                <input type="checkbox" className="checkbox" onChange={handleChange} />
                                <div className="knobs">
                                    <span>전체</span>
                                </div>
                                <div className="layer"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul className="docbox-col-cnts-wrap">
                    {list && list.map((doc) => {
                        return (
                            parseInt(doc.qaStatus) > 2 &&
                            <li className='docbox-col-cnts'>
                                <div className="docbox-col-top">
                                    <div className="docbox-col-path">
                                        <span className='docbox-col-path-text'>{formattedDateTime(new Date(doc.updateDateTime))}</span>
                                    </div>
                                    {parseInt(doc.qaStatus) === 4 &&
                                        <span className='docbox-col-badge-red' style={{cursor:"pointer"}} onClick={(e) => btnOnPopup(e, doc)}>반려</span>
                                    }
                                    {parseInt(doc.qaStatus) === 3 &&
                                        <span className='docbox-col-badge-green'>승인</span>
                                    }
                                </div>
                                <p className='docbox-col-title' onClick={() => handleClick(doc)}>{doc.title}</p>
                                <span className='docbox-col-name'>{doc.updateUserName}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
    const publish = (list) => {
        const handleChange = async (e) => {
            const list = await getDocList(e.target.checked, "Publish");
            publish(list);
        };
        setPublishList(
            <div className='docbox-col'>
                <div className="doccolumn-top">
                    <h3 className='doccolumn-title'>최근 게시</h3>
                    <div className="toggle-button-cover">
                        <div className="button-cover">
                            <div className="button b2" id="button-10">
                                <input type="checkbox" className="checkbox" onChange={handleChange} />
                                <div className="knobs">
                                    <span>전체</span>
                                </div>
                                <div className="layer"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul className="docbox-col-cnts-wrap">
                    {list && list.map((doc) => {
                        return (
                            <li className='docbox-col-cnts'>
                                <div className="docbox-col-top">
                                    <div className="docbox-col-path">
                                        <span className='docbox-col-path-text'>{formattedDateTime(new Date(doc.updateDateTime))}</span>
                                    </div>
                                </div>
                                <p className='docbox-col-title' onClick={() => handleClick(doc)}>{doc.title}</p>
                                <span className='docbox-col-name'>{doc.updateUserName}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
    const buttonHomeStyle = {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        cursor: "pointer"
    }
    if (openTopic)
        return (
            <div className='dochome'>
                <div className="admin">
                    <div className="admin-wrap">
                        <div style={buttonHomeStyle} onClick={() => setOpenTopic(false)}>
                            <i className='icoKdc24 folder'></i>
                            <p className='docbox-cnts'>문서함 홈으로</p>
                        </div>
                        <Topic current={state.current} isAdmin={LoginStates.admin.includes('Director')} isEditor={true} docBoxPath={props.docBox?.docBoxPath} topicSeq={state.topicSeq} />
                    </div>
                </div>
            </div>
        )
    else
    return (
        <div className='dochome'>
            <div className="title-wrap">
                <h1 className='dochome-title'>{props.docBox?.docBoxName}</h1>
                {(LoginStates.admin.includes('Director') || (editorInfo && editorInfo.isAdmin === 1)) &&
                    <button className="setting" onClick={() => setOpenSetting(true)}>
                        <i className="icoKdc20 setting-s"></i>관리
                    </button>
                }
            </div>
            {openSetting &&
                <DocHomeSetting setOpenSetting={setOpenSetting} docBox={props.docBox} setDocBox={props.setDocBox} setDocBoxList={props.setDocBoxList} />
            }
            <div className='dochome-top'>
                {boxTopicList}
                {bestList}
                {mostViewList}
            </div>
            <div className='dochome-btm'>
                {workingList}
                {requestList}
                {completeList}
                {publishList}
            </div>
            <PopUp setContent={() => btnOnPopup()} content={popupContent} />
        </div>
    )
}
export default DocHome;

const DocHomeSetting = (props) => {
    const LoginStates = useSelector(state => state.login);
    const [memberList, setMemberList] = useState([]);
    const [docBox, setDocBox] = useState({});
    const [nameValue, setNameValue] = useState({ box: "", admin: "", member: ""});
    const [editorList, setEditorList] = useState([]);
    const [matchedUsers, setMatchedUsers] = useState([]);
    const [position, setPosition] = useState({ top: 0, left: 0 })
    const splitKorean = (text) => text.normalize('NFD').replace(/[\u314e-\u314f\u1160-\u1161]/g, '');
    const userRef = useRef(null);

    useEffect(() => {
        getEditorList();
        const handleClickOutside = (e) => {
            if (userRef.current && !userRef.current.contains(e.target)) {
                setMatchedUsers([]);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        if (props.docBox) {
            setDocBox(props.docBox);
            setNameValue(prev => { return { ...prev, box: props.docBox.docBoxName } });
            getDocBoxMember(props.docBox.docBoxSeq);
        }
    }, [props.docBox]);

    const getEditorList = async () => {
        const response = await fetch(`api/Edit/GetEditor`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
        const result = await response.json();
        setEditorList(result.data.table);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
        return;
    };

    const handleKeyUp = (e) => {
        if (e.key !== "Backspace" && e.key !== "Delete" && e.key.length !== 1) return;
        const trimmedValue = e.target.value.trim();
        if (trimmedValue !== '') {
            const matched = editorList.filter(user => {
                const devUserName = splitKorean(user.devUserName).toLowerCase();
                const devUserId = user.devUserId.toLowerCase();
                const searchValue = splitKorean(trimmedValue).toLowerCase();
                user.isAdmin = e.target.name === "admin" ? 1 : 0;

                return (devUserName.includes(searchValue) || devUserId.includes(searchValue)) 
                    && !memberList.some(member => member.devUserId === user.devUserId && member.isAdmin === user.isAdmin);
            });
            setMatchedUsers(matched.slice(0, 5));
        } else {
            setMatchedUsers([]);
        }
    };
    const handleFocus = (e) => {
        let element = e.target;
        let totalTopOffset = 0;
        while (element) {
            // 부모 요소의 margin, padding 추가
            const { position, marginTop, paddingTop, gap, flexDirection } = getComputedSpacing(element);
            if (position === "absolute" || position === "fixed") break;
            totalTopOffset += marginTop + paddingTop;
            if (flexDirection !== "row")
                totalTopOffset += gap ?? 0;

            // 이전 형제 요소들 검사
            if (element.parentElement) {
                let sibling = element.previousElementSibling;
                while (sibling) {
                    const { marginTop, marginBottom } = getComputedSpacing(sibling);
                    totalTopOffset += marginTop + marginBottom;
                    sibling = sibling.previousElementSibling;
                }
            }
            element = element.parentElement; // 부모 요소로 이동
        }
        totalTopOffset -= 16;

        const rect = e.target.getBoundingClientRect();
        setPosition({ top: rect.bottom - totalTopOffset });
    }
    const getComputedSpacing = (element) => {
        const computedStyle = window.getComputedStyle(element);
        return {
            styleElement: element,
            position: computedStyle.position,
            marginTop: parseFloat(computedStyle.marginTop),
            marginBottom: parseFloat(computedStyle.marginBottom),
            paddingTop: parseFloat(computedStyle.paddingTop),
            paddingBottom: parseFloat(computedStyle.paddingBottom),
            marginLeft: parseFloat(computedStyle.marginLeft),
            marginRight: parseFloat(computedStyle.marginRight),
            paddingLeft: parseFloat(computedStyle.paddingLeft),
            paddingRight: parseFloat(computedStyle.paddingRight),
            gap: parseFloat(computedStyle.gap),
            flexDirection: computedStyle.flexDirection
        };
    }

    const addMemberList = (e, user) => {
        let workingTag = 'A';
        if (memberList.find(member => member.devUserId === user.devUserId && member.isAdmin === user.isAdmin)) {
            showToast("warning", "이미 추가된 멤버입니다.");
            return;
        } else if (memberList.find(member => member.devUserId === user.devUserId && member.isAdmin !== user.isAdmin)) {
            const type = user.isAdmin === 1 ? "관리자" : "작성자";
            if(!window.confirm(`${user.devUserName} 멤버를 ${type}로 변경하시겠습니까?`)) return;
            workingTag = 'U';
        }

        // 서버에 데이터 전송
        saveDocBoxMember(workingTag, user, user.isAdmin);
    };
    const handleDeleteMember = (type, user) => {
        const message = type === "admin" ? `${user.devUserName} 멤버를 작성자로 변경하시겠습니까?` : `${user.devUserName} 멤버를 삭제하시겠습니까?`
        if (window.confirm(message)) saveDocBoxMember(type === "admin" ? 'U' : 'D', user, type === "admin" ? 0 : null);
    };

    const getDocBoxMember = (docBoxSeq) => {
        const body = {
            docBoxSeq: docBoxSeq,
            devUserId: ''
        }
        fetch('api/Edit/GetDocBoxMember', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.message === 'Success') {
                    setMemberList(resultData.data.table || []);
                }
                else {
                    showToast('danger', '멤버 조회 실패');
                }
            });
    }

    const saveDocBoxMember = (workingTag, user, isAdmin) => {
        const body = {
            workingTag: workingTag,
            docBoxSeq: docBox.docBoxSeq,
            userId: user.devUserId,
            devUserId: LoginStates.userId,
            isAdmin: isAdmin ?? 0
        };
        fetch('api/Edit/SaveDocBoxMember', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                const tag = workingTag === "A" ? "추가" : workingTag === "U" ? "변경" : "삭제"
                if (resultData.message === 'Success') {
                    showToast('success', `${tag}되었습니다.`);
                    setNameValue(prev => { return { ...prev, [isAdmin ? "admin" : "member"]: "" } });
                    setMatchedUsers([]);
                    getDocBoxMember(docBox.docBoxSeq);
                }
                else {
                    showToast('danger', `${tag}하지 못했습니다.`);
                }
            });
    }

    const saveDocBox = () => {
        const newDocBoxName = nameValue.box.trim();
        if (newDocBoxName === "") {
            showToast("warning", "문서함명을 입력해주세요.");
            return;
        }
        const body = {
            workingTag: "U",
            devUserId: LoginStates.userId,
            docBoxSeq: docBox.docBoxSeq,
            docBoxName: newDocBoxName,
            docBoxPath: docBox.docBoxPath
        };
        fetch('api/Edit/SaveDocumentsBox', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.message === 'Success') {
                    props.setDocBoxList(resultData.data.table.length > 0 ? resultData.data.table : []);
                    props.setDocBox({ ...docBox, docBoxName: newDocBoxName });
                    showToast('success', '저장 완료');
                    props.setOpenSetting(false)
                }
                else {
                    showToast('danger', '저장 실패');

                }
            });
    };

    const handleInputChange = (e) => {
        setNameValue(prev => { return { ...prev, [e.target.name]: e.target.value } })
    };

    const checkClose = (e) => {
        if (nameValue.box.trim() !== props.docBox.docBoxName) {
            if (!window.confirm("문서함 이름이 변경되었습니다. 저장하지 않고 창을 닫으시겠습니까?")) return;
        }
        props.setOpenSetting(false);
    }

    const types = [
        { key: 'admin', label: '관리자', isAdmin: 1 },
        { key: 'member', label: '작성자', isAdmin: 0 },
    ];

    return (
        <div className="msg-popup-wrap dim">
            <div className="msg-popup center-box">
                <div className="modal">
                    <div className="modal-top">
                        <h3 className="modal-title">문서함 관리</h3>
                        <button className="btn-close" onClick={checkClose}>
                            <i className="icoKdc32 close"></i>
                        </button>
                    </div>
                    <div className="modal-cnts">
                        <div className="label-input-wrapper">
                            <label className="input-label">문서함 이름</label>
                            <form className="search-input">
                                <input
                                    name="box"
                                    placeholder="문서함 이름을 입력하고 엔터를 누르세요."
                                    value={nameValue.box}
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown}
                                />
                            </form>
                        </div>
                        {types.map(({key, label, isAdmin}) => (
                            <div className="label-input-wrapper">
                                <label className="input-label">문서함 {label}</label>
                                <form className="search-input">
                                    <i className="icoKdc20 add-g"></i>
                                    <input
                                        name={key}
                                        placeholder={`추가할 문서함 ${label}를 입력해주세요.`}
                                        value={nameValue[key]}
                                        onChange={handleInputChange}
                                        onKeyDown={handleKeyDown}
                                        onKeyUp={handleKeyUp}
                                        onFocus={handleFocus}
                                    />
                                </form>
                                <ul className="manager-list">
                                    {memberList.filter(x => x.isAdmin === isAdmin).map((x, index) => {
                                        return (
                                            <li key={index}>
                                                <p className="manager">{x.devUserName}</p>
                                                <button className="btn-delete" onClick={() => handleDeleteMember(key, x)}>
                                                    <i className="icoKdc12 delete"></i>
                                                </button>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        ))}
                        {matchedUsers.length > 0 && (
                            <div ref={userRef} className="matched-users" style={{ top: position.top + 'px' }}>
                                <ul className="user-list">
                                    {matchedUsers.map((user, index) => (
                                        <li key={index} onClick={(e) => addMemberList(e, user)}>
                                            {`${user.devUserName} (${user.companyName}) <${user.devUserId}>`}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="mail-list-btm">
                        <button className='btn-share' onClick={() => saveDocBox("U")}>저장</button>
                    </div>
                </div>
            </div>
        </div>
    )
}